import LocalizedStrings from 'localized-strings';

import { ComplianceApplicationProblemReason } from '../../libs/constants';

export default new LocalizedStrings({
  en: {
    findOutMoreLink: 'I want to know more',
    [ComplianceApplicationProblemReason.ForeignTaxResidency]: {
      description:
        'International regulation imposes strict rules on banks regarding accounts opened by individuals who are tax resident in other countries.',
    },
    [ComplianceApplicationProblemReason.TaxResidencyCountry]: {
      description:
        'International regulation imposes strict rules on banks regarding accounts opened by individuals who are tax resident in other countries.',
    },

    footer: 'Our teams remain at your disposal for further information.',
    title: 'Sorry, we can’t open your account',
    [ComplianceApplicationProblemReason.UsCitizenship]: {
      description:
        'The US administration is imposing strict constraints on European banks regarding accounts openings for US citizens.',
    },
  },
  fr: {
    [ComplianceApplicationProblemReason.UsCitizenship]: {
      description:
        'L’administration américaine impose aux banques européennes des contraintes strictes concernant les ouvertures de comptes de citoyen·nes américain·es.',
    },
    [ComplianceApplicationProblemReason.ForeignTaxResidency]: {
      description:
        'La régulation internationale impose aux banques des règles strictes en ce qui concerne les comptes ouverts par des personnes qui ont une résidence fiscale dans d’autres pays.',
    },
    [ComplianceApplicationProblemReason.TaxResidencyCountry]: {
      description:
        'La régulation internationale impose aux banques des règles strictes en ce qui concerne les comptes ouverts par des personnes qui ont une résidence fiscale dans d’autres pays.',
    },
    findOutMoreLink: 'En savoir plus',
    footer: "Nos équipes restent à votre disposition pour plus d'informations.",
    title: 'Nous ne pouvons pas ouvrir votre compte',
  },
} as const);
